import { render, staticRenderFns } from "./ExerciseProgressBar.vue?vue&type=template&id=07dda37c&scoped=true"
import script from "./ExerciseProgressBar.vue?vue&type=script&lang=js"
export * from "./ExerciseProgressBar.vue?vue&type=script&lang=js"
import style0 from "./ExerciseProgressBar.vue?vue&type=style&index=0&id=07dda37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dda37c",
  null
  
)

export default component.exports